import React,{useState,useEffect} from 'react'
import Grid from '@mui/material/Grid';
import { TextAreaInput1, TextInput } from '../../components/input';
import { ButtonFilled, ButtonOutlined } from '../../components/button';
import { useLocation, useNavigate } from 'react-router-dom';
import GoBack from '../../components/back/GoBack';
import ClientMenu from './ClientMenu';
import {RiCheckboxCircleFill,RiCheckboxCircleLine} from 'react-icons/ri';
import { MdCheckBox,MdCheckBoxOutlineBlank } from "react-icons/md";
import Uploader from '../../components/Uploader';
import { CreateClientService, GetClientDetailService, UpdateClientService } from '../../services/ClientService';
import toast from 'react-hot-toast';

function ClientCE() {

  const [loader,setloader] = useState(false)  
  const {state} = useLocation()

  const [data,setdata] = useState({
    name:'',
    mobile:'',
    email:'',
    address:'',
    aadhar_no:'',
    pan_no:'',
    photo:'',
    aadhar_file:'',
    pan_file:'',
    dl_file:'',
    client_type:'',
    secondary_name:'',
    secondary_contact:'',
    comments:'',
    is_active:true
  })

  const [error,seterror] = useState({
    name:'',
    mobile:'',
    email:'',
    address:'',
    aadhar_no:'',
    pan_no:'',
    photo:'',
    aadhar_file:'',
    pan_file:'',
    dl_file:'',
    client_type:'',
    secondary_name:'',
    secondary_contact:'',
    comments:'',
    is_active:''
  })

  const navigate = useNavigate()
  const location = useLocation()

  let path = location?.pathname?.split('/')[location?.pathname?.split('/').length -1]

  useEffect(()=>{
    if(location?.pathname?.split('/')[location?.pathname?.split('/').length -1] === 'edit'){
      geteditdata()
    }
  },[])

  async function geteditdata(){
    const response =  await GetClientDetailService(location?.state?._id);
    let d = response?.data?.datas[0]
    console.log("d here",d)
    if(d?._id !== undefined){
      delete d.created_by
      setdata({...d})
    }
  }

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name] : ''})
  }

  async function submitform(){

    const fd = new FormData()
    fd.append('name',data.name)
    fd.append('mobile',data.mobile)
    fd.append('email',data.email)
    fd.append('address',data.address)
    fd.append('aadhar_no',data.aadhar_no)
    fd.append('pan_no',data.pan_no)
    fd.append('is_active',data.is_active)
    fd.append('client_type',data.client_type)
    data?.photo?.name !== undefined &&  fd.append('photo',data.photo)
    data?.aadhar_file?.name !== undefined &&  fd.append('aadhar_file',data.aadhar_file)
    data?.pan_file?.name !== undefined &&  fd.append('pan_file',data.pan_file)
    data?.dl_file?.name !== undefined && fd.append('dl_file',data.dl_file)

    if(path !== 'edit'){
      const response = await CreateClientService(fd)
      if(response?.status === 201){
          toast.success("Client Detail Added Successfully!")
          resetform()
      }else{
          console.log("reponse?.data",response?.data)
      }
    }else{
      const response = await UpdateClientService(fd,state?._id)
      if(response?.status === 200){
        navigate(-1)
          toast.success("Client Detail Updated Successfully!")
          resetform()
      }else{
          console.log("reponse?.data",response?.data)
      }
    }
    
  }

  function resetform(){
     setdata({
        name:'',
        mobile:'',
        email:'',
        address:'',
        aadhar_no:'',
        pan_no:'',
        photo:'',
        aadhar_file:'',
        pan_file:'',
        dl_file:'',
        client_type:'',
        secondary_name:'',
        secondary_contact:'',
        comments:'',
        is_active:true
      })
      seterror({
        name:'',
        mobile:'',
        email:'',
        address:'',
        aadhar_no:'',
        pan_no:'',
        photo:'',
        aadhar_file:'',
        pan_file:'',
        dl_file:'',
        client_type:'',
        secondary_name:'',
        secondary_contact:'',
        comments:'',
        is_active:''
      })
  }

  return (
    <div className='box-border h-screen pt-5 md:pt-0 md:max-h-screen md:overflow-hidden'>
      <div className='block sm:flex'>
        <ClientMenu />
        <div className='pr-5 ml-5 md:min-h-screen md:max-h-screen md:h-screen md:overflow-y-scroll' >
          <div className='md:w-[85%] md:min-w-[38vw] md:max-w-[38vw] mt-4 '>
            <GoBack />
            <div className='pb-2 border-b'>
              <h6 className='font-[800] mb-1'>{location?.pathname?.split('/')[location?.pathname?.split('/').length -1] === 'edit' ? 'Edit' : 'Create'} Client Info</h6> 
              <h6 className='text-[11px] leading-tight font-[500] p-2 bg-slate-100 '>Use the below form to create or edit the Client information for your business .</h6> 
            </div> 
            <div className='w-[100%] md:overflow-x-hidden'>
              <h6 className='font-[800] text-[11px] bg-slate-100 p-[4px] mt-2'>Basic Info</h6>  
              <Grid container spacing={2}  >
                <Grid item xs={12}  md={6} >
                  <h6 className='text-[12px] mt-2'>Is this contact a person or a company?</h6> 
                  <div className='flex items-center mt-2'>
                    <div className='flex items-center mr-2' onClick={()=>setdata({...data,client_type:'person'})}>
                      {data.client_type === 'person' ?
                        <MdCheckBox size={20}  className='text-green-500'/>
                        :
                        <MdCheckBoxOutlineBlank size={20} className='text-slate-200' />}
                      <h6 className='ml-[5px] text-[12px]'>Person</h6>
                    </div> 

                    <div className='flex items-center' onClick={()=>setdata({...data,client_type:'company'})}>
                      {data.client_type === 'company' ?
                        <MdCheckBox size={20}  className='text-green-500'/>
                        :
                        <MdCheckBoxOutlineBlank size={20} className='text-slate-200' />}
                      <h6 className='ml-[5px] text-[12px]'>Business</h6>
                    </div> 
                  </div>

                  <TextInput 
                      mandatory={true}
                      label={'Name'}  
                      variant="standard"
                      name="name"
                      type="text"
                      value={data.name}
                      error={error.name}
                      handlechange={handlechange}
                      placeholder="Enter client name"
                      InputLabelProps={{
                          style: { color: '#fff', }, 
                      }}/>
                  <TextInput 
                      mandatory={true}
                      label={'Phone'}  
                      variant="standard"
                      name="mobile"
                      type="text"
                      value={data.mobile}
                      error={error.mobile}
                      handlechange={handlechange}
                      placeholder="Enter contact mobile"
                      InputLabelProps={{
                          style: { color: '#fff', }, 
                      }}/>
                  <TextInput 
                      label={'Email'}  
                      variant="standard"
                      name="email"
                      type="text"
                      value={data.email}
                      error={error.email}
                      handlechange={handlechange}
                      placeholder="Enter contact email"
                      InputLabelProps={{
                          style: { color: '#fff', }, 
                      }}/>

                  {data.client_type === 'company' &&
                    <TextInput 
                      mandatory={true}
                      label={'Company Name'}  
                      variant="standard"
                      name="company_name"
                      type="text"
                      value={data.company_name}
                      error={error.company_name}
                      handlechange={handlechange}
                      placeholder="Enter company name"
                      InputLabelProps={{
                          style: { color: '#fff', }, 
                      }}/>}

                  <div className='flex items-center mt-2 mr-2' onClick={()=>setdata({...data,is_active:!data.is_active})}>
                    {data.is_active ?
                      <MdCheckBox size={20}  className='text-green-500'/>
                      :
                      <MdCheckBoxOutlineBlank size={20} className='text-slate-200' />}
                    <h6 className='ml-[5px] text-[12px]'>Is Active</h6>
                  </div> 
                </Grid>

                <Grid item xs={12} md={6} >
                  <div className='mt-5' >
                    <TextAreaInput1 
                      label={'Address'}  
                      variant="standard"
                      name="address"
                      type="text"
                      value={data.address}
                      error={error.address}
                      handlechange={handlechange}
                      InputLabelProps={{
                          style: { color: '#fff', }, 
                      }}/>

                    <TextInput 
                      label={'Secondary Name'}  
                      variant="standard"
                      name="secondary_name"
                      type="text"
                      value={data.secondary_name}
                      error={error.secondary_name}
                      handlechange={handlechange}
                      placeholder="Enter client secondary name"
                      InputLabelProps={{
                          style: { color: '#fff', }, 
                      }}/>
                    <TextInput 
                      label={'Secondary Contact'}  
                      variant="standard"
                      name="secondary_contact"
                      type="text"
                      value={data.secondary_contact}
                      error={error.secondary_contact}
                      handlechange={handlechange}
                      placeholder="Enter secondary contact"
                      InputLabelProps={{
                      style: { color: '#fff', }, 
                    }}/>

                    <TextAreaInput1 
                      label={'Comments'}  
                      variant="standard"
                      name="comments"
                      type="text"
                      value={data.comments}
                      error={error.comments}
                      handlechange={handlechange}
                      InputLabelProps={{
                          style: { color: '#fff', }, 
                      }}/>
                  </div>
                </Grid>
              </Grid>

              <h6 className='font-[800] text-[11px] bg-slate-100 p-[4px] mt-2'>Other Info</h6>  

              <Grid container spacing={2}  >
                <Grid item xs={12}  md={6} >
                  {/* Made optional by setting required={false} */}
                  <Uploader error={error?.photo} name="photo" required={false} label={'Photo'} image={data?.photo}  setimagefunc={(e)=>{setdata({...data,photo:e});seterror({...error,photo:''})}}  removeimageuploadfunc = {()=>{setdata({...data,photo:''});seterror({...error,photo:''})}} />
                  <Uploader error={error?.aadhar_file} name="aadhar_file" required={false} label={'Addhar File'} image={data?.aadhar_file}  setimagefunc={(e)=>{setdata({...data,aadhar_file:e});seterror({...error,aadhar_file:''})}}  removeimageuploadfunc = {()=>{setdata({...data,aadhar_file:''});seterror({...error,aadhar_file:''})}} />
                </Grid>
                <Grid item xs={12}  md={6} >
                  <Uploader error={error?.pan_file} name="pan_file" required={false} label={'Pan File'} image={data?.pan_file}  setimagefunc={(e)=>{setdata({...data,pan_file:e});seterror({...error,pan_file:''})}}  removeimageuploadfunc = {()=>{setdata({...data,pan_file:''});seterror({...error,pan_file:''})}} />
                  <Uploader error={error?.dl_file} name="dl_file" required={false} label={'DL File'} image={data?.dl_file}  setimagefunc={(e)=>{setdata({...data,dl_file:e});seterror({...error,dl_file:''})}}  removeimageuploadfunc = {()=>{setdata({...data,dl_file:''});seterror({...error,dl_file:''})}} />
                </Grid>
              </Grid>

            </div>

            <div >
              <div className='flex items-center pt-5 mt-5 mb-10 border-t'>
                <div className='mr-2'>
                  <ButtonOutlined btnName={'Back'} onClick={()=>navigate(-1)} />
                </div>
                <div>
                  {loader ?   
                    <ButtonFilled btnName={loader ? 'Loading' : 'Save'} /> :
                    <ButtonFilled btnName={loader ? 'Loading' : 'Save'} onClick={()=>submitform(null)} /> }
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default ClientCE









//=========>> Old one 



// import React,{useState,useEffect} from 'react'
// import Grid from '@mui/material/Grid';
// import { TextAreaInput1, TextInput } from '../../components/input';
// import { ButtonFilled, ButtonOutlined } from '../../components/button';
// import { useLocation, useNavigate } from 'react-router-dom';
// import GoBack from '../../components/back/GoBack';
// import ClientMenu from './ClientMenu';
// import {RiCheckboxCircleFill,RiCheckboxCircleLine} from 'react-icons/ri';
// import { MdCheckBox,MdCheckBoxOutlineBlank } from "react-icons/md";
// import Uploader from '../../components/Uploader';
// import { CreateClientService, GetClientDetailService, UpdateClientService } from '../../services/ClientService';
// import toast from 'react-hot-toast';
// // import DailyTaskCE from './dailyTask/DailyTaskCE';

// function ClientCE() {

 
//   const [loader,setloader] = useState(false)  
//   const {state} = useLocation()

//   const [data,setdata] = useState({
//     name:'',
//     mobile:'',
//     email:'',
//     address:'',
//     aadhar_no:'',
//     pan_no:'',
//     photo:'',
//     aadhar_file:'',
//     pan_file:'',
//     dl_file:'',
//     client_type:'',
//     secondary_name:'',
//     secondary_contact:'',
//     comments:'',
//     is_active:true
//   })

//   const [error,seterror] = useState({
//     name:'',
//     mobile:'',
//     email:'',
//     address:'',
//     aadhar_no:'',
//     pan_no:'',
//     photo:'',
//     aadhar_file:'',
//     pan_file:'',
//     dl_file:'',
//     client_type:'',
//     secondary_name:'',
//     secondary_contact:'',
//     comments:'',
//     is_active:''
//   })

//   const navigate = useNavigate()
//   const location = useLocation()

//   let path = location?.pathname?.split('/')[location?.pathname?.split('/').length -1]

  
//   useEffect(()=>{

//     if(location?.pathname?.split('/')[location?.pathname?.split('/').length -1] === 'edit'){
//       geteditdata()
//     }
//   },[])

//   async function geteditdata(){
//     const response =  await GetClientDetailService(location?.state?._id);
//     let d = response?.data?.datas[0]
//     console.log("d here",d)
//     if(d?._id !== undefined){
//       delete d.created_by
//       setdata({...d})
//     }
    
   
//   }

//   // console.log("data?.operators",data?.operators)
//   function handlechange(e){
//     setdata({...data,[e.target.name] : e.target.value})
//     seterror({...error,[e.target.name] : ''})
//   }

//   async function submitform(){

//     const fd = new FormData()
//     fd.append('name',data.name)
//     fd.append('mobile',data.mobile)
//     fd.append('email',data.email)
//     fd.append('address',data.address)
//     fd.append('aadhar_no',data.aadhar_no)
//     fd.append('pan_no',data.pan_no)
//     fd.append('is_active',data.is_active)
//     fd.append('client_type',data.client_type)
//     data?.photo?.name !== undefined &&  fd.append('photo',data.photo)
//     data?.aadhar_file?.name !== undefined &&  fd.append('aadhar_file',data.aadhar_file)
//     data?.pan_file?.name !== undefined &&  fd.append('pan_file',data.pan_file)
//     data?.dl_file?.name !== undefined && fd.append('dl_file',data.dl_file)

//     if(path !== 'edit'){
//       const response = await CreateClientService(fd)
//       if(response?.status === 201){
//           toast.success("Client Detail Added Successfully!")
//           resetform()
//       }else{
//           console.log("reponse?.data",response?.data)
//       }
//     }else{
//       const response = await UpdateClientService(fd,state?._id)
//       if(response?.status === 200){
//         navigate(-1)
//           toast.success("Client Detail Updated Successfully!")
//           resetform()
//       }else{
//           console.log("reponse?.data",response?.data)
//       }
//     }
    
//   }

//   function resetform(){
//      setdata({
//         name:'',
//         mobile:'',
//         email:'',
//         address:'',
//         aadhar_no:'',
//         pan_no:'',
//         photo:'',
//         aadhar_file:'',
//         pan_file:'',
//         dl_file:'',
//         client_type:'',
//         secondary_name:'',
//         secondary_contact:'',
//         comments:'',
//         is_active:true
//       })
//       seterror({
//         name:'',
//         mobile:'',
//         email:'',
//         address:'',
//         aadhar_no:'',
//         pan_no:'',
//         photo:'',
//         aadhar_file:'',
//         pan_file:'',
//         dl_file:'',
//         client_type:'',
//         secondary_name:'',
//         secondary_contact:'',
//         comments:'',
//         is_active:''
//       })
//   }




  


//   return (
//     <div className='box-border h-screen pt-5 md:pt-0 md:max-h-screen md:overflow-hidden'>
//     <div className='block sm:flex'>
//         <ClientMenu />
//     <div className='pr-5 ml-5 md:min-h-screen md:max-h-screen md:h-screen md:overflow-y-scroll' >
    

  

//     <div className='md:w-[85%] md:min-w-[38vw] md:max-w-[38vw] mt-4 '>
//       <GoBack />
//      <div className='pb-2 border-b'>
//       <h6 className='font-[800] mb-1'>{location?.pathname?.split('/')[location?.pathname?.split('/').length -1] === 'edit' ? 'Edit' : 'Create'} Client Info</h6> 
//       <h6 className='text-[11px] leading-tight font-[500] p-2 bg-slate-100 '>Use the below form to create or edit the Client information for your business .</h6> 
//      </div> 
//      <div className='w-[100%] md:overflow-x-hidden'>

//       <h6 className='font-[800] text-[11px] bg-slate-100 p-[4px] mt-2'>Basic Info</h6>  
//       <Grid container spacing={2}  >
//         <Grid item xs={12}  md={6} >

//         <h6 className='text-[12px] mt-2'>Is this contact a person or a company?</h6> 
//         <div className='flex items-center mt-2'>
//         <div className='flex items-center mr-2' onClick={()=>setdata({...data,client_type:'person'})}>
//           {data.client_type === 'person' ?
//           <MdCheckBox size={20}  className='text-green-500'/>
//           :
//           <MdCheckBoxOutlineBlank size={20} className='text-slate-200' />}
//           <h6 className='ml-[5px] text-[12px]'>Person</h6>
//         </div> 

//         <div className='flex items-center' onClick={()=>setdata({...data,client_type:'company'})}>
//          {data.client_type === 'company' ?
//           <MdCheckBox size={20}  className='text-green-500'/>
//           :
//           <MdCheckBoxOutlineBlank size={20} className='text-slate-200' />}
//           <h6 className='ml-[5px] text-[12px]'>Business</h6>
//         </div> 
//         </div>

//           <TextInput 
//               mandatory={true}
//               label={'Name'}  
//               variant="standard"
//               name="name"
//               type="text"
//               value={data.name}
//               error={error.name}
//               handlechange={handlechange}
//               placeholder="Enter client name"
//               InputLabelProps={{
//                   style: { color: '#fff', }, 
//               }}/>
//                <TextInput 
//               mandatory={true}
//             label={'Phone'}  
//             variant="standard"
//             name="mobile"
//             type="text"
//             value={data.mobile}
//             error={error.mobile}
//             handlechange={handlechange}
//             placeholder="Enter contact mobile"
//             InputLabelProps={{
//                 style: { color: '#fff', }, 
//             }}/>
//              <TextInput 
//             label={'Email'}  
//             variant="standard"
//             name="email"
//             type="text"
//             value={data.email}
//             error={error.email}
//             handlechange={handlechange}
//             placeholder="Enter contact email"
//             InputLabelProps={{
//                 style: { color: '#fff', }, 
//             }}/>


//         {data.client_type === 'company' &&
//           <TextInput 
//             mandatory={true}
//             label={'Company Name'}  
//             variant="standard"
//             name="company_name"
//             type="text"
//             value={data.company_name}
//             error={error.company_name}
//             handlechange={handlechange}
//             placeholder="Enter company name"
//             InputLabelProps={{
//                 style: { color: '#fff', }, 
//             }}/>}


// <div className='flex items-center mt-2 mr-2' onClick={()=>setdata({...data,is_active:!data.is_active})}>
//           {data.is_active ?
//           <MdCheckBox size={20}  className='text-green-500'/>
//           :
//           <MdCheckBoxOutlineBlank size={20} className='text-slate-200' />}
//           <h6 className='ml-[5px] text-[12px]'>Is Active</h6>
//         </div> 
           





       
            
//         </Grid>
//         <Grid item xs={12} md={6} >
        
         

//          <div className='mt-5' >
         


//          <TextAreaInput1 
//             label={'Address'}  
//             variant="standard"
//             name="address"
//             type="text"
//             value={data.address}
//             error={error.address}
//             handlechange={handlechange}
//             InputLabelProps={{
//                 style: { color: '#fff', }, 
//             }}/>

// <TextInput 
//               label={'Secondary Name'}  
//               variant="standard"
//               name="secondary_name"
//               type="text"
//               value={data.secondary_name}
//               error={error.secondary_name}
//               handlechange={handlechange}
//               placeholder="Enter client secondary name"
//               InputLabelProps={{
//                   style: { color: '#fff', }, 
//               }}/>
//                <TextInput 
//                 label={'Secondary Contact'}  
//                 variant="standard"
//                 name="secondary_contact"
//                 type="text"
//                 value={data.secondary_contact}
//                 error={error.secondary_contact}
//                 handlechange={handlechange}
//                 placeholder="Enter secondary contact"
//                 InputLabelProps={{
//                 style: { color: '#fff', }, 
//             }}/>

//               <TextAreaInput1 
//             label={'Comments'}  
//             variant="standard"
//             name="comments"
//             type="text"
//             value={data.comments}
//             error={error.comments}
//             handlechange={handlechange}
//             InputLabelProps={{
//                 style: { color: '#fff', }, 
//             }}/>

       

        
        


//          </div>

         


       

        
       
//         </Grid>
//       </Grid>

//       <h6 className='font-[800] text-[11px] bg-slate-100 p-[4px] mt-2'>Other Info</h6>  


//        <Grid container spacing={2}  >
//             <Grid item xs={12}  md={6} >
//                 <Uploader error={error?.photo} name="photo" required={true} label={'Photo'} image={data?.photo}  setimagefunc={(e)=>{setdata({...data,photo:e});seterror({...error,photo:''})}}  removeimageuploadfunc = {()=>{setdata({...data,photo:''});seterror({...error,photo:''})}} />
//                 <Uploader error={error?.aadhar_file} name="aadhar_file" required={true} label={'Addhar File'} image={data?.aadhar_file}  setimagefunc={(e)=>{setdata({...data,aadhar_file:e});seterror({...error,aadhar_file:''})}}  removeimageuploadfunc = {()=>{setdata({...data,aadhar_file:''});seterror({...error,aadhar_file:''})}} />
//             </Grid>
//             <Grid item xs={12}  md={6} >
//                 <Uploader error={error?.pan_file} name="pan_file" required={true} label={'Pan File'} image={data?.pan_file}  setimagefunc={(e)=>{setdata({...data,pan_file:e});seterror({...error,pan_file:''})}}  removeimageuploadfunc = {()=>{setdata({...data,pan_file:''});seterror({...error,pan_file:''})}} />
//                 <Uploader error={error?.dl_file} name="dl_file" required={true} label={'DL File'} image={data?.dl_file}  setimagefunc={(e)=>{setdata({...data,dl_file:e});seterror({...error,dl_file:''})}}  removeimageuploadfunc = {()=>{setdata({...data,dl_file:''});seterror({...error,dl_file:''})}} />
//             </Grid>
//        </Grid>
//       </div>

   
//    <div >
//     <div className='flex items-center pt-5 mt-5 mb-10 border-t'>
//         <div className='mr-2'>
//         <ButtonOutlined btnName={'Back'} onClick={()=>navigate(-1)} />
//         </div>
//         <div>
//         {loader ?   
//         <ButtonFilled btnName={loader ? 'Loading' : 'Save'} /> :
//         <ButtonFilled btnName={loader ? 'Loading' : 'Save'} onClick={()=>submitform(null)} /> }
//         </div>
//     </div>
//     </div>
//     </div>
//     </div>
//     </div>
//     </div>
   
//   )
// }

// export default ClientCE